function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */

import { Formatter } from '@deephaven/jsapi-utils';
import EmptyIrisGridModel from "./EmptyIrisGridModel.js";
import MissingPartitionError, { isMissingPartitionError } from "./MissingPartitionError.js";
function isPartitionedTableWithBaseTable(partitionedTable) {
  return 'getBaseTable' in partitionedTable && typeof partitionedTable.getBaseTable === 'function';
}
class IrisGridPartitionedTableModel extends EmptyIrisGridModel {
  /**
   * @param dh JSAPI instance
   * @param table Partitioned table to be used in the model
   * @param formatter The formatter to use when getting formats
   */
  constructor(dh, partitionedTable) {
    var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Formatter(dh);
    super(dh, formatter);
    _defineProperty(this, "partitionedTable", void 0);
    this.partitionedTable = partitionedTable;
  }
  get isPartitionRequired() {
    return true;
  }
  get isPartitionAwareSourceTable() {
    return false;
  }
  get isReversible() {
    return false;
  }
  displayString(value, columnType, columnName) {
    return '';
  }
  close() {
    this.partitionedTable.close();
  }
  get columns() {
    return this.partitionedTable.columns;
  }
  get partitionColumns() {
    return this.partitionedTable.keyColumns;
  }
  get columnCount() {
    return this.columns.length;
  }
  getColumnIndexByName(columnName) {
    return this.columns.findIndex(column => column.name === columnName);
  }
  textForColumnHeader(column, depth) {
    var _this$columns$column$;
    return (_this$columns$column$ = this.columns[column].name) !== null && _this$columns$column$ !== void 0 ? _this$columns$column$ : '';
  }
  partitionKeysTable() {
    var _this = this;
    return _asyncToGenerator(function* () {
      return _this.partitionedTable.getKeyTable();
    })();
  }
  partitionBaseTable() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      if (isPartitionedTableWithBaseTable(_this2.partitionedTable)) {
        return _this2.partitionedTable.getBaseTable();
      }
      // Fallback to the key table if the base table API is not available
      return _this2.partitionedTable.getKeyTable();
    })();
  }
  partitionMergedTable() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      return _this3.partitionedTable.getMergedTable();
    })();
  }
  partitionTable(partitions) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      try {
        var table = yield _this4.partitionedTable.getTable(partitions);
        if (table == null) {
          // TODO: Will be unnecessary with https://github.com/deephaven/deephaven-core/pull/5050
          throw new MissingPartitionError('Partition not found');
        }
        return table;
      } catch (e) {
        if (!isMissingPartitionError(e)) {
          throw new MissingPartitionError('Unable to retrieve partition');
        } else {
          throw e;
        }
      }
    })();
  }
}
export default IrisGridPartitionedTableModel;
//# sourceMappingURL=IrisGridPartitionedTableModel.js.map